export default "__VITE_ASSET__CRNlBYsl__"